export const siteChromeNavigationStoreKey = "chrome:navigation";
export const expirationInMs = 5 * 60 * 1000;
